import { Box,  Tooltip, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import "./NavMenuControl.scss"
import { useEffect, useState } from "react";
export default function NavMenuItem(props) {
  const navigate = useNavigate();
  const [showSubMenus, setShowSubMenus] = useState(false);

  const handleClick = () => {
    if (props.subModules?.length > 0) setShowSubMenus(!showSubMenus);
    if (props.subModules?.length > 0 && props.popupState ) {
      props.popupState.open();
      return;
    }
    if (props.type === "openMenu") {
      props.onClick();
    } else if (props.subModules?.length < 1) {
      navigate(props.link);
    }
  };

 

  useEffect(() => {
    setShowSubMenus(props.isActive);
  }, [props.isActive]);
  const toolTipStyle = {
    tooltip: {
      // sx: {
      //   borderRadius: "0px",
      //   backgroundColor: "#242424 !important",
      //   color: "#ffffff !important",
      // },
    },
    // arrow: {
    //   sx: {
    //     color: "#242424 !important",
    //   },
    // },
  };
  return (
    <>
      <Tooltip
        className="tooltipMenu"
        title={  props.isActive ? null : props.title}
        placement="right"
        arrow
        componentsProps={toolTipStyle}
        PopperProps={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 5],
              },
            },
          ],
        }}
      >
        <Box
          component={Link}
          to={props.link}
          className={`cursor-pointer  ${props.isActive ? "nav-menuControl-active" : "nav-menuControl-inactive"}`}
          onClick={() => handleClick()}
        >
          <Box className="nav-menu-icon">
            {props.isActive ? props.activeIcon : props.inActiveIcon}
          </Box>
       
            <Box flexGrow={1}>
              <Typography
                className={`nav-menuControl-text ${
                  props.isActive ? "nav-menuControl-text-active" : ""
                }`}
              >
                {props.title}
              </Typography>
            </Box>
          
        </Box>
      </Tooltip>
   
    </>

  );
}
